import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate, useParams} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import Login from "../../Login";
import {Content} from "antd/es/layout/layout";
import AppSiderActivitatsId from "./menus/AppSiderActivitatsId";
import ActivitatsIdExercicis from "./content/ActivitatsIdExercicis";

const AlumnesId = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id_problema} = useParams();
    const [dades, setDades] = (useState<any>())
    const [pantalla, setPantalla] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            //checkDades();
        }
    }, [id_problema]);

    function setPnt(value: number) {
        setPantalla(value);
    }

    if (isLoggedIn) {
        return (
            <>
                <AppSiderActivitatsId setPantalla={setPnt}/>
                <Content style={{padding: '0 24px', minHeight: 280}}>
                    {pantalla === 0 && <ActivitatsIdExercicis/>}
                </Content>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default AlumnesId;
